module.exports = __webpack_public_path__ + "static/media/user.0e86457c.svg";